(function () {
    if (window.__doorbustersHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.doorbusters = window.Branch.doorbusters || {};
    window.Branch.doorbusters.sliders = window.Branch.doorbusters.sliders || {};
    window.__doorbustersHasFired = true;

    function updateProductTiles(firstCurrent, doorbustersData) {
        const productTiles = document.querySelectorAll(`.collection-wrapper .product-tile[data-handle="${firstCurrent.handle}"]`);
        if(productTiles.length > 0){
            productTiles.forEach((tile) => {
                let saleTag = tile.querySelector('.sale');
                if(saleTag){
                    saleTag.innerHTML = 'DEAL OF THE DAY';
                    saleTag.setAttribute('data-sale-text', 'DEAL OF THE DAY');
                    saleTag.setAttribute('data-display', true);
                    saleTag.setAttribute('style', `display: block; background-image: -moz-linear-gradient(96deg, ${doorbustersData.doorbusters_primary_color} 28.31%, ${doorbustersData.doorbusters_secondary_color} 56.64%, ${doorbustersData.doorbusters_primary_color} 76.21%); background-image: -webkit-linear-gradient(96deg, ${doorbustersData.doorbusters_primary_color} 28.31%, ${doorbustersData.doorbusters_secondary_color} 56.64%, ${doorbustersData.doorbusters_primary_color} 76.21%); background-image: linear-gradient(96deg, ${doorbustersData.doorbusters_primary_color} 28.31%, ${doorbustersData.doorbusters_secondary_color} 56.64%, ${doorbustersData.doorbusters_primary_color} 76.21%);`);
                } else {
                    let newSaleTagHTML = `<div data-dc-text="false" data-sale-text="DEAL OF THE DAY" class="sale" data-product-handle="${firstCurrent.handle}" data-display="true" style="display: block; background-image: -moz-linear-gradient(96deg, ${doorbustersData.doorbusters_primary_color} 28.31%, ${doorbustersData.doorbusters_secondary_color} 56.64%, ${doorbustersData.doorbusters_primary_color} 76.21%); background-image: -webkit-linear-gradient(96deg, ${doorbustersData.doorbusters_primary_color} 28.31%, ${doorbustersData.doorbusters_secondary_color} 56.64%, ${doorbustersData.doorbusters_primary_color} 76.21%); background-image: linear-gradient(96deg, ${doorbustersData.doorbusters_primary_color} 28.31%, ${doorbustersData.doorbusters_secondary_color} 56.64%, ${doorbustersData.doorbusters_primary_color} 76.21%);">DEAL OF THE DAY</div>`;
                    tile.querySelector('.product-image-hover').insertAdjacentHTML('end', newSaleTagHTML);
                }
            })
        }
    }

    function initDoorbustersCTASection(doorbustersSection, parent, firstCurrent, allInTheFuture, doorbustersData){
        console.log('initDoorbustersCTASection!', firstCurrent)
        const displayCTA = doorbustersSection.getAttribute('data-display-cta-section');

        if (displayCTA === 'true') {
            const ctaSection = parent.querySelector('.doorbusters-cta-section');
            if (ctaSection && firstCurrent) {
                const title = ctaSection.querySelector('.doorbusters-cta-section__title');
                const titlePart2 = ctaSection.querySelector('.doorbusters-cta-section__title-part-2');
                const subtitle = ctaSection.querySelector('.doorbusters-cta-section__subtitle');

                if (title) {
                    title.textContent = firstCurrent.title_part_1;
                }

                if (titlePart2) {
                    titlePart2.textContent = allInTheFuture ? firstCurrent.productTitle.replace(/[A-Za-z]/g, "_") : firstCurrent.title_part_2;
                }

                if (subtitle && firstCurrent.subtitle && !allInTheFuture) {
                    const decodedSubtitle = decodeURIComponent(firstCurrent.subtitle.replace(/\+/g, ' '));
                    const firstPIndex = decodedSubtitle.indexOf('<p>');
                    const lastPIndex = decodedSubtitle.lastIndexOf('</p>');

                    if (firstPIndex !== -1 && lastPIndex !== -1) {
                        const extractedContent = decodedSubtitle.substring(firstPIndex, lastPIndex + 4).replaceAll('<p>', '').replaceAll('</p>', '');
                        subtitle.innerHTML = extractedContent;
                    }
                }

                if(subtitle && allInTheFuture){
                    subtitle.innerHTML = "Today’s deal drops at 9:00 AM ET. You won’t want to miss it. Until then, shop Black Friday pricing on our most popular picks.";
                }

                if (firstCurrent.url && !allInTheFuture) {
                    const ctaElements = ctaSection.querySelectorAll('.doorbusters-cta-section__cta');
                    ctaElements.forEach((cta, index) => {
                        if(index == 0){
                            const button = document.createElement('button');
                            button.className = cta.className;
                            button.classList.add('quick-view-link');
                            button.textContent = cta.textContent;
                            button.setAttribute('data-url', `/products/${firstCurrent.handle}?view=quick-view`);
                            button.setAttribute('data-addon-handle', `${firstCurrent.handle}`);
                            button.setAttribute('data-addon-id', `${firstCurrent.productId}`);
                            button.setAttribute('data-addon-price', `${firstCurrent.productPrice}`);
                            button.type = 'button';
                            cta.parentNode.replaceChild(button, cta);
                        } else {
                            cta.setAttribute('href', firstCurrent.url);
                        }
                    });
                }

                if(allInTheFuture){
                    const ctaElements = ctaSection.querySelectorAll('.doorbusters-cta-section__cta');
                    ctaElements.forEach((cta, index) => {
                        if(index == 0){
                            cta.setAttribute('href', '/collections/upgrade-and-save');
                             cta.innerText = 'SHOP THE SALE';
                        } else {
                            cta.remove();
                        }
                        
                    });
                }

                if (firstCurrent.image && !allInTheFuture) {
                    const image = ctaSection.querySelector('.doorbusters__image');
                    if (image) {
                        image.setAttribute('src', firstCurrent.image);
                        image.setAttribute('srcset', window.Branch.functions.returnSrcSet(firstCurrent.image, 900));
                        let imageContainer = image.closest('.doorbusters__image-container');
                        if (imageContainer) {
                        const labelDiv = document.createElement('div');
                        labelDiv.className = 'doorbusters__image-label';

                        const labelSpan = document.createElement('span');
                        labelSpan.textContent = 'OUR BEST DISCOUNT EVER: 25% OFF';

                        labelDiv.appendChild(labelSpan);
                        imageContainer.appendChild(labelDiv);
                    }
                    }
                } else if (allInTheFuture) {
                    const image = ctaSection.querySelector('.doorbusters__image');
                    if (image) {
                        image.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0124/5662/4187/files/icon-guj-02.png?v=1759283890');
                        image.setAttribute('srcset', '');
                        image.setAttribute('alt', '');
                        image.closest('.doorbusters__item').setAttribute('data-locked', true)
                    }
                }

                if (firstCurrent.end_time) {
                    const countdownElement = ctaSection.querySelector('.doorbusters__image-text-container');

                    if(allInTheFuture){
                        countdownElement.innerHTML = '<h4 class="doorbusters__image-title">DEAL REVEAL IN</h4><span class="doorbusters-cta-section__countdown"></span>'
                    }
                    const countdownElementSpan = countdownElement.querySelector('.doorbusters-cta-section__countdown');

                    if (countdownElement && countdownElementSpan) {
                        let endTime = new Date(new Date(firstCurrent.end_time).toLocaleString('en-US', { timeZone: 'America/New_York' }));
                        if(allInTheFuture){
                            endTime = new Date(new Date(firstCurrent.start_time).toLocaleString('en-US', { timeZone: 'America/New_York' }));
                        }
                        const updateCountdown = () => {
                            const currentEasternTime = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
                            const timeDiff = endTime - currentEasternTime;

                            if (timeDiff <= 0) {
                                countdownElement.closest('.doorbusters__item-outer').querySelectorAll('.doorbusters__image-title').forEach((title) => {
                                    title.textContent = 'REFRESH TO SEE DEAL';
                                    // title.style.display = 'none';
                                })
                                countdownElementSpan.textContent = '00:00:00';
                                clearInterval(countdownInterval);
                                return;
                            }

                            const hours = Math.floor(timeDiff / (1000 * 60 * 60));
                            const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
                            const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
                            const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
                            
                            
                            countdownElementSpan.textContent = formattedTime;
                        };
                        const countdownInterval = setInterval(updateCountdown, 1000);
                        updateCountdown();
                    }

                     if(allInTheFuture){
                        let standInOverlay = ctaSection.querySelector('.doorbusters__item-stand-in-overlay');
                        if (standInOverlay) {
                            const overlayCountdownDiv = document.createElement('div');
                            overlayCountdownDiv.className = 'doorbusters__item-stand-in-overlay-countdown';
                            overlayCountdownDiv.innerHTML = '<h4 class="doorbusters__image-title">DEAL REVEAL IN</h4>';

                            const countdownSpan = ctaSection.querySelector('.doorbusters-cta-section__countdown');
                            if (countdownSpan) {
                                overlayCountdownDiv.appendChild(countdownSpan);
                            }

                            standInOverlay.insertBefore(overlayCountdownDiv, standInOverlay.firstChild);

                            standInOverlay.querySelector('.loading-icon-container').innerHTML = `<svg class="padlock" xmlns="http://www.w3.org/2000/svg" width="38" height="47" viewBox="0 0 38 47" fill="none">
                                    <rect x="0.675497" y="18.3934" width="35.9547" height="28.0717" rx="3.95009" stroke="white" stroke-width="0.832928"/>
                                    <path d="M9.1583 17.9748C8.54971 13.3034 9.59648 3.96045 18.6522 3.96045C27.708 3.96045 28.7547 13.3034 28.1461 17.9748" stroke="white" stroke-width="0.832928"/>
                                    <path d="M6.56954 18.1502C5.79498 12.5595 7.12723 1.37805 18.6528 1.37805C30.1783 1.37805 31.5104 12.5595 30.7358 18.1502" stroke="white" stroke-width="0.832928"/>
                                    <circle cx="19.0904" cy="28.0497" r="4.40097" stroke="white" stroke-width="0.832928"/>
                                    <path d="M16.9014 31.9912V40.7502H21.2809V31.9912" stroke="white" stroke-width="0.832928"/>
                                </svg>`;
                        }
                    }
                }
                updateProductTiles(firstCurrent, doorbustersData);
            } 
            ctaSection.setAttribute('data-initialized', 'true');
        }
    }

    function initDoorbusters(doorbustersSection, parent){
        const dataScript = document.getElementById('doorbusters-data');
        if (!dataScript) return;

        let doorbustersData;
        try {
            doorbustersData = JSON.parse(dataScript.textContent);
        } catch (error) {
            console.error('Failed to parse doorbusters data:', error);
            return;
        }
        dataScript.remove();

        const doorbusterItems = Array.from(doorbustersSection.querySelectorAll('.doorbusters__item'));
        const getCurrentEasternTime = () => {
            return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
        };

        const currentTime = getCurrentEasternTime();
        const itemsWithData = [];
        let firstCurrent = null;
        let firstEntry = null;
        let nextFuture = null;
        let expiredPresent = false;
        let allInTheFuture

        if(doorbusterItems.length > 0){
            doorbusterItems.forEach(item => {
                const handle = item.getAttribute('data-handle');
                const matchingDoorbuster = doorbustersData.doorbusters.find(db => db.handle === handle);

                if (matchingDoorbuster) {
                    const startTime = new Date(new Date(matchingDoorbuster.start_time).toLocaleString('en-US', { timeZone: 'America/New_York' }));
                    const endTime = new Date(new Date(matchingDoorbuster.end_time).toLocaleString('en-US', { timeZone: 'America/New_York' }));

                    if (!firstEntry) {
                        firstEntry = JSON.parse(JSON.stringify(matchingDoorbuster));
                    } else {
                        const firstEntryStartTime = new Date(new Date(firstEntry.start_time).toLocaleString('en-US', { timeZone: 'America/New_York' }));
                        if (startTime < firstEntryStartTime) {
                            firstEntry = JSON.parse(JSON.stringify(matchingDoorbuster));
                        }
                    }

                    let status;
                    if (currentTime < startTime) {
                        status = 'future';
                    } else if (currentTime >= startTime && currentTime <= endTime) {
                        status = 'current';
                    } else {
                        status = 'expired';
                        expiredPresent = true;
                    }

                    item.setAttribute('data-status', status);
                    if (status === 'expired' || status === 'current') {
                        const imageContainer = item.querySelector('.doorbusters__image-container');
                        if (imageContainer) {
                            const labelDiv = document.createElement('div');
                            labelDiv.className = 'doorbusters__image-label';
                            const labelSpan = document.createElement('span');
                            labelSpan.textContent = status === 'expired' ? 'EXPIRED' : 'LIVE';
                            labelDiv.appendChild(labelSpan);
                            imageContainer.appendChild(labelDiv);
                        }
                        let url = document.querySelector('body.template-collection-2025_bfcm_doorbusters') ? `/products/${matchingDoorbuster.handle}` : matchingDoorbuster.url;
                        item.setAttribute('data-url', url);
                    }

                    if (status === 'current' && firstCurrent == null) {
                        firstCurrent = JSON.parse(JSON.stringify(matchingDoorbuster));
                    }

                    if (status === 'future') {
                        if(!nextFuture) {
                            nextFuture = JSON.parse(JSON.stringify(matchingDoorbuster));
                        } else {
                            const nextFutureStartTime = new Date(new Date(nextFuture.start_time).toLocaleString('en-US', { timeZone: 'America/New_York' }));
                            if (startTime < nextFutureStartTime) {
                                nextFuture = JSON.parse(JSON.stringify(matchingDoorbuster));
                            }
                        }
                        const loadingIconContainer = item.querySelector('.loading-icon-container');
                        if (loadingIconContainer) {
                            const labelDiv = document.createElement('div');
                            labelDiv.className = 'doorbusters__packlock-label';

                            const labelSpan = document.createElement('span');
                            labelSpan.textContent = matchingDoorbuster.title_part_1.replaceAll(':', '');

                            labelDiv.appendChild(labelSpan);
                            loadingIconContainer.appendChild(labelDiv);
                            loadingIconContainer.insertAdjacentHTML(
                                'afterbegin',
                                `<svg class="padlock" xmlns="http://www.w3.org/2000/svg" width="38" height="47" viewBox="0 0 38 47" fill="none">
                                    <rect x="0.675497" y="18.3934" width="35.9547" height="28.0717" rx="3.95009" stroke="white" stroke-width="0.832928"/>
                                    <path d="M9.1583 17.9748C8.54971 13.3034 9.59648 3.96045 18.6522 3.96045C27.708 3.96045 28.7547 13.3034 28.1461 17.9748" stroke="white" stroke-width="0.832928"/>
                                    <path d="M6.56954 18.1502C5.79498 12.5595 7.12723 1.37805 18.6528 1.37805C30.1783 1.37805 31.5104 12.5595 30.7358 18.1502" stroke="white" stroke-width="0.832928"/>
                                    <circle cx="19.0904" cy="28.0497" r="4.40097" stroke="white" stroke-width="0.832928"/>
                                    <path d="M16.9014 31.9912V40.7502H21.2809V31.9912" stroke="white" stroke-width="0.832928"/>
                                </svg>`
                            );
                            loadingIconContainer.setAttribute('data-lock-icon', 'true');
                        }
                        const itemInner = item.querySelector('.doorbusters__item-inner');
                        if(itemInner){
                            itemInner.querySelector('.doorbusters__image-container').innerHTML = `<img class="doorbusters__image" src="https://cdn.shopify.com/s/files/1/0124/5662/4187/files/icon-guj-02.png?v=1759283890">`;
                            itemInner.querySelector('.doorbusters__image-title').innerHTML = `25% of the ___________`;
                        }
                    }

                    itemsWithData.push({
                        element: item,
                        startTime: startTime
                    });
                }

            });
        } else {
            doorbustersData.doorbusters.forEach(matchingDoorbuster => {
                const startTime = new Date(new Date(matchingDoorbuster.start_time).toLocaleString('en-US', { timeZone: 'America/New_York' }));
                const endTime = new Date(new Date(matchingDoorbuster.end_time).toLocaleString('en-US', { timeZone: 'America/New_York' }));

                if (!firstEntry) {
                    firstEntry = JSON.parse(JSON.stringify(matchingDoorbuster));
                } else {
                    const firstEntryStartTime = new Date(new Date(firstEntry.start_time).toLocaleString('en-US', { timeZone: 'America/New_York' }));
                    if (startTime < firstEntryStartTime) {
                        firstEntry = JSON.parse(JSON.stringify(matchingDoorbuster));
                    }
                }

                let status;
                if (currentTime < startTime) {
                    status = 'future';
                } else if (currentTime >= startTime && currentTime <= endTime) {
                    status = 'current';
                } else {
                    status = 'expired';
                    expiredPresent = true;
                }

                if (status === 'current' && firstCurrent == null) {
                    firstCurrent = JSON.parse(JSON.stringify(matchingDoorbuster));
                }

                if (status === 'future') {
                    if(!nextFuture) {
                        nextFuture = JSON.parse(JSON.stringify(matchingDoorbuster));
                    } else {
                        const nextFutureStartTime = new Date(new Date(nextFuture.start_time).toLocaleString('en-US', { timeZone: 'America/New_York' }));
                        if (startTime < nextFutureStartTime) {
                            nextFuture = JSON.parse(JSON.stringify(matchingDoorbuster));
                        }
                    }
                }

            });
        }
        

        if(!firstCurrent && expiredPresent == false) {
            firstCurrent = firstEntry;
            allInTheFuture = true;
        } else if (!firstCurrent && expiredPresent) {
            firstCurrent = nextFuture;
            allInTheFuture = true;
        }

        initDoorbustersCTASection(doorbustersSection, parent, firstCurrent, allInTheFuture, doorbustersData);

        if(doorbusterItems.length > 0) {
            itemsWithData.sort((a, b) => a.startTime - b.startTime);
            const swiperWrapper = doorbustersSection.querySelector('.swiper-wrapper');

            itemsWithData.forEach(itemData => {
                swiperWrapper.appendChild(itemData.element);
                itemData.element.removeAttribute('data-handle');
            });

            doorbusterItems.forEach(item => {
                const status = item.getAttribute('data-status');
                if (status === 'current' || status === 'expired') {
                    let startX = 0;
                    let startY = 0;
                    let startTime = 0;

                    item.addEventListener('mousedown', (e) => {
                        startX = e.clientX;
                        startY = e.clientY;
                        startTime = Date.now();
                    });

                    item.addEventListener('touchstart', (e) => {
                        startX = e.touches[0].clientX;
                        startY = e.touches[0].clientY;
                        startTime = Date.now();
                    }, { passive: true });

                    item.addEventListener('click', (e) => {
                        const endX = e.clientX;
                        const endY = e.clientY;
                        const endTime = Date.now();
                        const deltaX = Math.abs(endX - startX);
                        const deltaY = Math.abs(endY - startY);
                        const deltaTime = endTime - startTime;
                        const threshold = 10; 
                        const timeThreshold = 500; 

                        let legitClick = window.Branch.functions.isTouchDevice() == true ? deltaX < threshold && deltaY < threshold && deltaTime < timeThreshold : true;

                        if (legitClick) {
                            const url = item.getAttribute('data-url');
                            if (url) {
                                e.preventDefault();
                                e.stopPropagation();
                                window.location.href = url;
                            }
                        }
                    });
                }
            });
        }
    }

    function initDoorbustersSlider(doorbustersSection, parent){
        let slides = doorbustersSection.querySelectorAll('.doorbusters__item.swiper-slide');
        if(slides.length == 0) return;
        let cascadeIndex = parseInt(slides[0].getAttribute('data-cascade-order'));

        doorbustersSection.querySelectorAll('.doorbusters__item.swiper-slide').forEach((updatedSlide, index) => {
        updatedSlide.setAttribute('data-cascade-order', `${cascadeIndex}`);
        const width = window.innerWidth;

        if (
            (width < 900 && index < 2) ||
            (width < 1024 && index < 3) ||
            (width >= 1024 && index < 4)
        ) {
            cascadeIndex++;
        }
    });
        let parentId = parent.getAttribute('id');
        let enable_autoscroll = doorbustersSection.getAttribute('data-enable-autoscroll') == 'true';
        let autoscroll_interval = 1000 * parseInt(doorbustersSection.getAttribute('data-autoscroll-interval'));
        let desktop_images_across = parseFloat(doorbustersSection.getAttribute('data-desktop-images-across'));
        let autoplay = !enable_autoscroll ? false : {delay: autoscroll_interval, disableOnInteraction: true}
        let mobileInitialSlide = window.innerWidth < 900 ? 0 : 0;

        window.Branch.doorbusters.sliders[`${parentId}`] = new Swiper(`#${parentId} .doorbusters__slider`, {
            spaceBetween: 20,
            slidesPerView: 1.1,
            autoplay: autoplay,
            touchRatio: 0.2,
            loop: false,
            initialSlide: mobileInitialSlide,
            navigation: {
                nextEl: `#${parentId} .doorbusters__nav-right`,
                prevEl: `#${parentId} .doorbusters__nav-left`,
            },
            breakpoints: {
                600: {
                        slidesPerView: 1.5,
                },
                900: {
                        slidesPerView: 2.5,
                },
                1024: {
                        slidesPerView: desktop_images_across,
                }
            }
        });
    }

function actionsOnVisible(doorbustersSection, parent){
        doorbustersSection.setAttribute('data-interacted', true);
        window.Branch.nav.handleUpdateSrcSet(null, '.doorbusters__image', '.doorbusters__image-container', 900);     
        initDoorbusters(doorbustersSection, parent);
        initDoorbustersSlider(doorbustersSection, parent);
    }    

function initDoorbustersCallback(doorbustersSection, parent, type){
        let fromLoad = doorbustersSection.closest('.homepage-content-container') && doorbustersSection.closest('.homepage-content-container').getAttribute('data-origin') == 'load';

        if(type == 'from-copy' && fromLoad == false){
            actionsOnVisible(doorbustersSection, parent);
        } else if(!doorbustersSection.closest('.homepage-content-container')) {
            actionsOnVisible(doorbustersSection, parent);
        } else {
            const scrollHandler = function () {
            const containerRect = {top: 0, left: 0, bottom: window.innerHeight, right: window.innerWidth, width: window.innerWidth, height: window.innerHeight};
            const targetRect = doorbustersSection.getBoundingClientRect();

            const isVisible =
                targetRect.bottom > containerRect.top &&
                targetRect.top < containerRect.bottom;

            if (
                isVisible &&
                doorbustersSection.getAttribute("data-interacted") !== "true"
            ) {
                actionsOnVisible(doorbustersSection, parent);
                doorbustersSection.setAttribute("data-interacted", "true");
                window.removeEventListener("scroll", scrollHandler);
            }
        };

        window.addEventListener("scroll", scrollHandler);
        }
    }

    window.Branch.doorbusters.doorbustersInitOnLoad = function(type){
        let doorbustersSections = document.querySelectorAll('.doorbusters:not([data-initialized="true"])');
        doorbustersSections.forEach((doorbustersSection) => {
            let parent = doorbustersSection.closest('.shopify-section');
            doorbustersSection.setAttribute('data-initialized', true);
            if(type == 'from-copy'){
                 initDoorbustersCallback(doorbustersSection, parent, type)
            } else {
                 window.Branch.functions.fireOnUserInteraction(initDoorbustersCallback, '.homepage-content-container', doorbustersSection, doorbustersSection, parent);
             }
        })  
    }

    if (document.readyState === "complete") {
        window.Branch.doorbusters.doorbustersInitOnLoad('regular'); 
    } else {
        window.addEventListener("load", () => window.Branch.doorbusters.doorbustersInitOnLoad('regular'));
    }
  })();
